module.exports = __webpack_public_path__ + "static/media/bussitre-icon.f0b9538f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bussitre-icon.png
// module id = 142
// module chunks = 0